import { ButtonHTMLAttributes, forwardRef, useEffect } from 'react'

import { useMaybeLayoutContext } from '@/src/context'

import { useAppDispatch, useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'
import { selectIsOpenMedia, setIsOpenMedia } from '@/src/store/slices/media'
import { setIsOpenChat } from '@/src/store/slices/chat'

/** @public */
export interface MediaToggleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  closeBar?: boolean
}

/**
 * The `MediaToggle` component is a button that toggles the visibility of the `MediaPanel` component.
 * @public
 */
export const MediaToggle = forwardRef<HTMLButtonElement, MediaToggleProps>(function MediaToggle(
  { closeBar, ...otherProps }: MediaToggleProps,
  ref
) {
  const dispatch = useAppDispatch()
  const layoutContext = useMaybeLayoutContext()
  const isOpen = useAppSelector(selectIsOpenMedia)
  const { primary_color } = useAppSelector(selectBranding)

  const handleClick = () => {
    if (!isOpen) {
      // Close other panels when opening media
      layoutContext?.widget?.dispatch?.({ msg: 'hide_participants' })
      dispatch(setIsOpenChat(false))
    }

    dispatch(setIsOpenMedia(!isOpen))
  }

  useEffect(() => {
    // Close media panel when participants panel is opened
    if (layoutContext?.widget?.state?.showParticipants) {
      dispatch(setIsOpenMedia(false))
    }
  }, [layoutContext?.widget?.state?.showParticipants, dispatch])

  return (
    <div style={{ display: 'flex', position: closeBar ? 'static' : 'relative' }}>
      <button
        ref={ref}
        onClick={handleClick}
        className="lk-button media-toggle"
        aria-pressed={isOpen && !closeBar}
        {...otherProps}
      >
        {otherProps.children}
      </button>
    </div>
  )
})
